import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ScheduledPublishGroupId = Brand<number, 'ScheduledPublishGroupId'>;
export const ScheduledPublishGroupId = createBranded<ScheduledPublishGroupId>();
